import type { SummaryDashboard as RemoteSummaryDashboard } from "../../../../api/useSummaryDashboards";
import t from "../../../../i18n";
import type { Dashboard } from "../../Dashboards/hook/api/dashboard";

export type SummaryDashboard = Omit<RemoteSummaryDashboard, "createdAt" | "updatedAt">;

export const SUMMARY_ID = "__summary__";
export const PLANT_STATE_ID = "__plant_state__";

export const isPlantStateTab = (tabId: string, pathname: string) =>
  tabId === PLANT_STATE_ID && pathname.includes("plant-state");

export function createSummaryDashboard(projectId: string): Dashboard {
  return {
    id: SUMMARY_ID,
    title: t("project.document.title.summary"),
    description: null,
    projectId,
    published: true,
    createdAt: 0,
    updatedAt: 0,
    blocks: [],
    readonly: false,
    createdByUserName: null,
    createdByUserId: "",
    updatedByUserName: null,
  };
}
